export const FETCH_SIMPLE_WORK_ORDER_NAME_REQUEST =
  'FETCH_SIMPLE_WORK_ORDER_NAME_REQUEST';
export const FETCH_SIMPLE_WORK_ORDER_NAME_SUCCESS =
  'FETCH_SIMPLE_WORK_ORDER_NAME_SUCCESS';
export const FETCH_SIMPLE_WORK_ORDER_NAME_ERROR =
  'FETCH_SIMPLE_WORK_ORDER_NAME_ERROR';
